class EvermindGotsProduct {
  constructor(section) {
    this.section = section;
    this.items = [...section.querySelectorAll('.g2-reveal')];
    this.observer = null;

    this.init();
  }

  init() {
    this.section.classList.add('js-ready');

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      this.showAll();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    this.items.forEach((item) => {
      this.observer.observe(item);
    });
  }

  showAll() {
    this.items.forEach((item) => {
      item.classList.add('is-visible');
    });
  }
}

function initEvermindGotsProduct(root = document) {
  root
    .querySelectorAll('[data-evermind-gots-product]')
    .forEach((section) => {
      if (section.dataset.g2Initialized === 'true') return;

      section.dataset.g2Initialized = 'true';

      new EvermindGotsProduct(section);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initEvermindGotsProduct();
  });
} else {
  initEvermindGotsProduct();
}

/*
 * Shopify Theme Editor desteği.
 * Section yeniden render edildiğinde animasyon sistemi
 * yeni DOM üzerinde tekrar başlatılır.
 */
document.addEventListener('shopify:section:load', (event) => {
  initEvermindGotsProduct(event.target);
});